/** @format */

import React from "react";
import AddonsList from "./AddonsList";
import { useSelector } from "react-redux";
import Loader from "../../../Layout/Loader";

const ProductAddons = () => {
  const { isLoading } = useSelector((state) => state.app);
  return (
    <div className="page-body main-project">
      {isLoading && <Loader />}
      <AddonsList />
    </div>
  );
};

export default ProductAddons;
